import {
  Block,
  Button,
  LabelMedium,
  Spinner,
  useStyletron,
} from "@mezo-org/mezo-clay"

type SwapModalFormSubmitButtonProps = {
  disabled: boolean
  isLoadingState: boolean
}

export default function SwapModalFormSubmitButton({
  disabled,
  isLoadingState,
}: SwapModalFormSubmitButtonProps) {
  const [css, theme] = useStyletron()

  return (
    <Button
      size="large"
      type="submit"
      disabled={disabled}
      overrides={{
        BaseButton: {
          style: () => ({
            width: "100%",
            ...(isLoadingState
              ? { ":disabled": { background: theme.colors.black } }
              : {}),
          }),
        },
      }}
    >
      {isLoadingState ? (
        <Block
          className={css({
            display: "flex",
            alignItems: "center",
            gap: theme.sizing.scale400,
          })}
        >
          <Spinner $size={theme.sizing.scale700} $color={theme.colors.black} />
          <LabelMedium color={theme.colors.white}>
            Calculating best prices...
          </LabelMedium>
        </Block>
      ) : (
        "Review"
      )}
    </Button>
  )
}
